// extracted by mini-css-extract-plugin
export default {"title":"Q7KLIv","mobile":"uC3gZy","info":"SG_fmw"};